/* istanbul ignore file */
import { optional as codecOptional, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CreateTenantDataParser = /* #__PURE__ */ parsers.object([
    ['name', codecString],
    ['abbreviatedName', codecString, 'abbreviated_name'],
    ['hubspotCompanyId', /* #__PURE__ */ codecOptional(codecString), 'hubspot_company_id'],
]);
export class CreateTenantData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CreateTenantDataParser.decode(input).map(res => new CreateTenantData(res));
    }
    static unsafeDecode(input) {
        return CreateTenantData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CreateTenantDataParser.encode(data);
    }
    static schema() {
        return CreateTenantDataParser.schema();
    }
}
